import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface UserListCustomerHeaderProps
  extends HeaderContext<GatewayUserModel, GatewayUserModel['customer']> {}

export const UserListCustomerHeader = (): // props: UserListCustomerHeaderProps,
ReactNode => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return t('delmonicos-shared-sdk.outputs-user.customer');
};
